/* eslint-disable */
export default {
  forward: 'Transférer',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
